import React from 'react';
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import s from './CouponTotal.scss';
import classnames from 'clsx';
import {shorten} from '../../../domain/utils/shorten';
import {isFreeShippingCoupon} from '../../../domain/utils/coupon';

export enum CouponTotalDataHook {
  CouponTotalRoot = 'CouponTotal.CouponTotalRoot',
  CouponTotalLabel = 'CouponTotal.CouponTotalLabel',
  CouponTotalCode = 'CouponTotal.CouponCode',
  CouponTotalDiscountValue = 'CouponTotal.CouponDiscountValue',
}

export interface CouponTotalProps {
  shouldShowDivider?: boolean;
}

export const CouponTotal = ({shouldShowDivider = true}: CouponTotalProps) => {
  const {t} = useTranslation();
  const {isRTL} = useEnvironment();
  const {cartModel, estimatedTotals, sideCartCouponAndNote, freeDeliveryCouponTextOnCart} =
    useControllerProps().cartStore;
  const appliedCoupon = estimatedTotals?.appliedCoupon || cartModel.appliedCoupon;
  const couponAmount =
    estimatedTotals?.priceSummary?.discount.formattedConvertedAmount ?? cartModel.discount.formattedConvertedAmount;

  const shouldShowDividerClass = (sideCartCouponAndNote && shouldShowDivider) || !sideCartCouponAndNote;

  const getCouponRowValueText = (): string => {
    if (freeDeliveryCouponTextOnCart && isFreeShippingCoupon(appliedCoupon)) {
      return t('cart.summary.discount.free_delivery');
    }
    /* istanbul ignore next */
    if (isRTL) {
      return `${couponAmount}-`;
    }
    return `-${couponAmount}`;
  };

  return (
    <div
      data-hook={CouponTotalDataHook.CouponTotalRoot}
      className={shouldShowDividerClass && classnames(s.divider, s.root)}>
      <dl>
        <dt>
          <span data-hook={CouponTotalDataHook.CouponTotalLabel}>{t('cart.coupon')}</span>{' '}
          <span data-hook={CouponTotalDataHook.CouponTotalCode}>
            {freeDeliveryCouponTextOnCart ? shorten(appliedCoupon.code.toUpperCase(), 10, '...') : appliedCoupon.code}
          </span>
        </dt>
        <dd
          data-hook={CouponTotalDataHook.CouponTotalDiscountValue}
          data-wix-coupon-discount-value={CouponTotalDataHook.CouponTotalDiscountValue}>
          {getCouponRowValueText()}
        </dd>
      </dl>
    </div>
  );
};
